import Component from '../abstracts/Component';
import {replacePageInHistory} from '../utils/BrowserHistoryUtils';

export default class HistoryManagerComponent extends Component {
  get SELECTORS() {
    return {
      pagersContainer: '.js-item-pagination'
    }
  }
  constructor() {
    super();
  }
  bindEvents() {
    const {pagersContainer} = this.SELECTORS;
    $(document).on('click', '.w-card-product[data-product-id]', function (e) {
      const currentProduct = $(this);
      const productId = currentProduct.data('product-id');
      const productPage = currentProduct.data('product-page');
      const href = $(currentProduct).find('.js-product-card').attr('href');
      if(productId && href) {
        let query = location.origin + location.pathname;
        let params = location.search;
        let pageSupportsPagination = $(pagersContainer).length > 0;
        if(params.length != 0) {
          let paramPage = params.match(/page?=/);
          let paramPageVal = params.match(/page?=\d+/);
          if(paramPage != null && paramPageVal != null) {
            let OldParam = paramPageVal.toString();
            let newParam = paramPage.toString() + productPage;
            query+= params.replace(OldParam, newParam);
          } else {
            query+= params;
          }
        }
        if(!pageSupportsPagination && !query.match(/[\?&]preload=/) && query.match(/[\?&]page=\d+/)) {
          query+='&preload=true';
        }
        replacePageInHistory(
          query,
          {
            focusElement: '.w-card-product[data-product-id=' + productId + ']'
          },
          '',
          !pageSupportsPagination && query.includes('page=')
        );
      }
    });
  }
  render() {
    this.bindEvents();
    console.info('[HistoryManager] init');
  }
}
